import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import SearchByParty from '@Components/Search/SearchByParty'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'

const PublicSearchByPublisherTab = () => {
    const { publicSearchPublishersStore } = useContext(StoresContext)

    return (
        <div className="public-search-by-writer-tab">
            <SearchByParty
                searchPartyStore={publicSearchPublishersStore}
                partyQueryStore={publicSearchPublishersStore}
                partyDetailsCardComponent={SearchResultPartyDetailsCard}
                syncSearchTermsToUrl
            />
        </div>
    )
}
export default observer(PublicSearchByPublisherTab)
